// Lets code outside the React tree (e.g. axios interceptors in UserContext)
// imperatively navigate using the data router created in RouterShell, without
// UserContext and RouterShell importing each other directly.
let routerInstance = null;

export function registerRouter(router) {
  routerInstance = router;
}

export function getRouter() {
  return routerInstance;
}
